// Types
import type { ReactNode } from 'react';
import type { TAlertColor, TAlertProps } from './Alert.type';

// Components
import { AlertIconError, AlertIconInformation, AlertIconSuccess, AlertIconWarning } from './Alert.icons';

export const ALERT_COLORS: TAlertColor[] = ['success', 'warning', 'error', 'information']
export const ALERT_COLOR: { [key in TAlertColor]: key } = {
	success: 'success',
	warning: 'warning',
	error: 'error',
	information: 'information'
}

export const ALERT_DEFAULT_PROPS: TAlertProps = {
	color: ALERT_COLOR.information,
}

export const DEFAULT_ICON: { [key in TAlertColor]: ReactNode } = {
	success: AlertIconSuccess,
	warning: AlertIconWarning,
	error: AlertIconError,
	information: AlertIconInformation
}
